import React, { useContext } from "react";
import OwLabel from "../OwLabel/OwLabel";
import OwS3DownloadLink from "../OwS3DownloadLink/OwS3DownloadLink";
import IAttachment from "../../../models/IAttachment";
import ICatalog_Item from "../../../models/ICatalog_Item";
import { SocketContext } from "../../../contexts/SocketContext";
import SupplierContext from "../../../contexts/SupplierContext";
import UserContext from "../../../contexts/UserContext";

type Props = {
    catalogItem: ICatalog_Item;
    readOnly?: boolean;
    className?: string;
};

export const FilesDownloadSection = (props: Props) => {
    const socket = useContext(SocketContext)!;
    const supplierModel = useContext(SupplierContext);
    const userModel = useContext(UserContext);

    const fileAttachments = (props.catalogItem.Attachments || []).filter((attachment) => !attachment.image_seq);

    return (
        <>
            {fileAttachments?.length ? (
                <div className={"mt-2"}>
                    <OwLabel title={"files"} isBold={true} />
                    <div className="d-flex flex-wrap">
                        {fileAttachments.map((attachment) => {
                        return (
                            <OwS3DownloadLink
                                key={attachment.guid}
                                attachment={attachment}
                                leftIconName={"fad fa-download"}
                                title={"download"}
                                isReadOnly={props.readOnly}
                                className={props.className}
                            />
                        );
                    })}
                    </div>
                    
                </div>
            ) : null}
        </>
    );
};
